import React from 'react';
import { motion } from 'motion/react';
import { FiSun, FiMoon } from 'react-icons/fi';

const AnimatedThemeToggle = ({ isDarkMode, toggleTheme }) => {
  return (
    <div className="relative">
      {/* Toggle Switch Container */}
      <motion.div
        className={`
          relative w-16 h-9 rounded-full cursor-pointer
          transition-colors duration-300
          ${isDarkMode 
            ? 'bg-gray-700 border-gray-600' 
            : 'bg-blue-200 border-blue-300'
          }
          border-2
          ${isDarkMode ? 'shadow-[inset_0_2px_4px_rgba(0,0,0,0.4)]' : 'shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]'}
        `}
        onClick={toggleTheme}
        role="button"
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleTheme();
          }
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        {/* Sliding Ball */}
        <motion.div
          className={`
            absolute top-1 w-6 h-6 rounded-full shadow-lg
            ${isDarkMode 
              ? 'bg-gray-800 border-gray-700' 
              : 'bg-white border-gray-300'
            }
            border
          `}
          animate={{
            x: isDarkMode ? 34 : 2,
          }}
          transition={isDarkMode ? springTransition : bounceTransition}
        >
          {/* Inner icon on the ball */}
          <div className="w-full h-full flex items-center justify-center">
            <motion.div
              animate={{ rotate: isDarkMode ? 360 : 0 }}
              transition={{ duration: 0.5 }}
            >
              {isDarkMode ? (
                <FiMoon className="w-3 h-3 text-blue-300" />
              ) : (
                <FiSun className="w-3 h-3 text-yellow-600" />
              )}
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

// Animation configurations
const bounceTransition = {
  duration: 0.8,
  ease: bounceEase,
};

const springTransition = {
  type: "spring",
  stiffness: 700,
  damping: 30,
};

// Custom bounce easing function from https://easings.net/#easeOutBounce
function bounceEase(x) {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
}

export default AnimatedThemeToggle; 